import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@ui-components/shared.module';
import { LibManagementGroupModalComponent } from './management-group-modal.component';

@NgModule({
  declarations: [
    LibManagementGroupModalComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    LibManagementGroupModalComponent
  ]
})
export class LibManagementGroupModalModule { }
